/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Connexion\ConnexionComponent\ConnexionComponent.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Monday December 11th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday December 11th 2023 5:10:50 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import ConnexionModule from "../ConnexionModule/ConnexionModule";
import Styles from "Content/Connexion/ConnexionComponent/ConnexionComponent.module.css";
import translator from "MultiLanguage/TranslationWrapper";
import { ConnexionDataAndInfo } from "Type/Connextion.type";
import { useEffect, useState } from "react";
import UserService from "Services/Users/UserService";

type ConnexionPageProps = {
    displayName: boolean,
    userID?: string,
    order?: string,
    orderby?: string,
    page: number,
    withAdmin?: boolean
    setOrderBy?: Function,
    setOrder?: Function,
    showTitle: boolean
}

function ConnexionPage(props: ConnexionPageProps) {
    const [myData, setMyData]: any = useState({
        connexion: [],
        count: {
            countConnexion: 0,
            refresh: { failed: 0, success:0 },
            credential: { failed: 0, success: 0 }
        }
    });

    useEffect(() => {
            const requestToSend = {
                from: props.orderby ?? "week",
                order: props.order ?? "desc",
                per_page: props.page ? 20*props.page : 20,
                withadmin: props.withAdmin ?? undefined,
                page: 1,
                userid: props.userID
            };
            UserService.getConnexions(requestToSend)
            .then((res: ConnexionDataAndInfo) => {
                setMyData(res);
                const url = window.location;
                const searchParams = new URLSearchParams(url.search);
                searchParams.set("page", props.page ? props.page.toString() : "1");
                window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
            })
            .catch((err) => {
                console.error(err);
            });
    }, [props.userID, props.withAdmin]);

    return (
        <div className={`${Styles.pageholder}`}>
            {
                props.showTitle ?
                <h1>{translator.decode("stats.connexions")}</h1>
                : null
            }
            <ConnexionModule
                displayName={props.displayName}
                data={myData.connexion}
                countConnexion={myData.count}
                userID={props.userID}
                order={props.order}
                setOrder={props.setOrder}
                orderBy={props.orderby}
                setOrderBy={props.setOrderBy}
                withAdmin={props.withAdmin}
            />
        </div>
    );
};

export default ConnexionPage;
